import objectHash from 'object-hash';

import { QueryClient, QueryKey } from '@tanstack/react-query';

export function initQueryClient() {
    const queryKeyHashFn = (key: QueryKey) => objectHash(key, { algorithm: 'md5', unorderedArrays: true });

    const retry = (failureCount: number, error: Error) => {
        if (error instanceof TypeError) {
            return failureCount < 3;
        }

        return false;
    };

    return new QueryClient({
        defaultOptions: {
            queries: {
                queryKeyHashFn,
                retry,
                staleTime: Infinity
            }
        }
    });
}
